module.exports = __webpack_public_path__ + "static/media/curriculum-vitae.b5169297.png";